const MainKey = {
  MAP: 'map',
  ADDRESS: 'address',
  AUTH: 'auth',
  POSTS: 'posts',
  SITES: 'sites',
  LAYERS: 'layers',
};

export const authKeys = {
  all: [MainKey.AUTH],
  login: [MainKey.AUTH, 'login'],
};

export const postsKeys = {
  all: [MainKey.POSTS],
  yearMonth: [MainKey.POSTS, 'yearMonth'],
  list: (param) => [MainKey.POSTS, 'list', ...param],
  comment: [MainKey.POSTS, 'comments'],
};

export const sitesKeys = {
  all: [MainKey.SITES],
  list: [MainKey.SITES, 'list'],
  detail: (param) => [MainKey.SITES, 'detail', ...param],
  memo: (param) => [MainKey.SITES, 'memo', ...param],
};

export const mapKeys = {
  all: [MainKey.MAP],
};

export const addressKeys = {
  all: [MainKey.ADDRESS],
};

export const layersKeys = {
  all: (params) => [MainKey.LAYERS, 'all', { ...params }],
  detail: (params) => [MainKey.LAYERS, 'detail', { ...params }],
  east: (params) => [MainKey.LAYERS, 'east', { ...params }],
  center: (params) => [MainKey.LAYERS, 'center', { ...params }],
  publish: (params) => [MainKey.LAYERS, 'publish', { ...params }],
};

// 필수 !! invalidate 필요
const queryKeys = {
  MainKey,
  authKeys,
  postsKeys,
  mapKeys,
  addressKeys,
  sitesKeys,
  layersKeys,
};
export default queryKeys;
